export default {"src":"/_next/static/image/public/logo-large.47eab4187bbebb3365d61486e64d76b3.svg","height":33,"width":171};